import store from '@/store'
const commonView = () => import(/* webpackChunkName: "common" */ '@/components/common/commonView.vue')

const lotteryKind = () => import(/* webpackChunkName: "lottery-kind" */ '@/views/game-lobby/lottery-kind.vue')
const electronicGamesMakers = () => import(/* webpackChunkName: "lottery-kind" */ '@/views/game-lobby/electronic-games-makers')
const electronicGamesMakersList = () => import(/* webpackChunkName: "lottery-kind" */ '@/views/game-lobby/electronic-games-makers-list')
const selfLotteryRtp = () => import(/* webpackChunkName: "lottery-kind" */ '@/views/game-lobby/self-lottery-rtp')
const selfLotteryDraw = () => import(/* webpackChunkName: "lottery-kind" */ '@/views/game-lobby/self-lottery-draw')
const drawSetting = () => import(/* webpackChunkName: "lottery-kind" */ '@/views/game-lobby/draw-setting')
const selfLotteryBetTime = () => import(/* webpackChunkName: "lottery-kind" */ '@/views/game-lobby/self-lottery-bet-time')
const selfLotteryDailyTime = () => import(/* webpackChunkName: "lottery-kind" */ '@/views/game-lobby/self-lottery-daily-time')
export default {
  path: 'game-lobby',
  name: 'game-lobby',
  meta: { title: '游戏', Submenu: true, menuOpenid: "12" },
  component: commonView,
  redirect: '/main/:GD/game-lobby/lottery-kind',
  children: [
    {
      path: 'lottery-kind',
      name: 'lottery-kind',
      meta: { title: '彩种总表' },
      component: lotteryKind,
      beforeEnter: (to, from, next) => {
        if (store.getters.getpermission.gameswitch[0] != '1') return next({ name: 'no-permission', params: to.params })
        next()
      },
    },
    {
      path: 'electronic-games',
      name: 'electronic-games',
      meta: { title: '外站游戏' },
      component: electronicGamesMakers,
      beforeEnter: (to, from, next) => {
        if (store.getters.getpermission.gameswitch[2] != '1') return next({ name: 'no-permission', params: to.params })
        next()
      },
    },
    {
      path: 'electronic-games-list',
      name: 'electronic-games-list',
      meta: { title: '彩种总表' },
      component: electronicGamesMakersList,
      beforeEnter: (to, from, next) => {
        if (store.getters.getpermission.gameswitch[2] != '1') return next({ name: 'no-permission', params: to.params })
        next()
      },
    },
    {
      path: 'self-lottery-rtp',
      name: 'self-lottery-rtp',
      meta: { title: '自开彩RTP调整' },
      component: selfLotteryRtp,
      beforeEnter: (to, from, next) => {
        if (store.getters.getpermission.gameset[0] != '1') return next({ name: 'no-permission', params: to.params })
        next()
      },
    },
    {
      path: 'self-lottery-draw',
      name: 'self-lottery-draw',
      meta: { title: '自开彩开奖设定' },
      component: selfLotteryDraw,
      beforeEnter: (to, from, next) => {
        if (store.getters.getpermission.gameset[2] != '1') return next({ name: 'no-permission', params: to.params })
        next()
      },
    },
    {
      path: 'draw-setting',
      name: 'draw-setting',
      meta: { title: '各游戏开奖设定' },
      component: drawSetting,
      beforeEnter: (to, from, next) => {
        if (store.getters.getpermission.gameset[2] != '1') return next({ name: 'no-permission', params: to.params })
        next()
      },
    },
    {
      path: 'self-lottery-bet-time',
      name: 'self-lottery-bet-time',
      meta: { title: '自开彩下注时间设定' },
      component: selfLotteryBetTime,
      beforeEnter: (to, from, next) => {
        if (store.getters.getpermission.gameset[4] != '1') return next({ name: 'no-permission', params: to.params })
        next()
      },
    },
    {
      path: 'self-lottery-daily-time',
      name: 'self-lottery-daily-time',
      meta: { title: '日開彩結算時間设定' },
      component: selfLotteryDailyTime,
      beforeEnter: (to, from, next) => {
        if (store.getters.getpermission.settlement[0] != '1') return next({ name: 'no-permission', params: to.params })
        next()
      },
    }
  ]
}